module.exports = __webpack_public_path__ + "static/media/text-with-video-bg.5f5ae062.svg";